import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, CloseIcon, RowsContainer } from '@streamr/tv-ui';
import { useCallback, useMemo, useState } from 'react';
import styled from 'styled-components';
import { BroadcastStateService } from '../../services/broadcaststate/BroadcastStateService';
import { BottomRight, Popup } from '../../utils/popups';
import { AbstractPopup } from './AbstractPopup';
import { PopupCssPreset } from './Popup.styles';
export function NetworkStatisticsPopup({ reject, resolve, ...props }) {
    const broadcast = BroadcastStateService.getOutput().useRequiredActiveBroadcast();
    const link = useMemo(() => {
        return `https://live-crawler.streamr.network/?streamId=${encodeURIComponent(broadcast.streamId)}&partition=0`;
    }, [broadcast.streamId]);
    const [iframeKey, setIframeKey] = useState(crypto.randomUUID());
    const refreshIframe = useCallback(() => {
        setIframeKey(crypto.randomUUID());
    }, []);
    return (_jsx(NetworkStatisticsPopupRoot, { reject: reject, translateFn: BottomRight, ...props, children: _jsxs(NetworkStatisticsPopupContent, { children: [_jsxs(HeaderRow, { children: [_jsx(Heading, { children: "Network statistics" }), _jsx(Button, { kind: "pill", onClick: () => reject(), children: _jsx(CloseIcon, {}) })] }), _jsx(StyledIframe, { title: "Network statistics", src: link, width: "100%", height: "100%", credentialless: '' }, iframeKey), _jsx(StyledButton, { type: "button", onClick: refreshIframe, children: "Refresh" })] }) }));
}
const NetworkStatisticsPopupRoot = styled(AbstractPopup) `
    ${PopupCssPreset.Fullscreen};
    --Popup_Padding: 1.5rem;
    @media (min-width: 30rem) {
        ${PopupCssPreset.Center};
        --Popup_Width: 80vw;
        --Popup_Height: 80vh;
        --Popup_BorderRadius: 1rem;

    }
`;
const NetworkStatisticsPopupContent = styled(RowsContainer) `
    width: 100%;
    height: 100%;
    gap: 2rem;
`;
const HeaderRow = styled.div `
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 1rem;
    flex-direction: row-reverse;
    @media (min-width: 30rem) {
        flex-direction: row;
        justify-content: space-between;
    }
`;
const Heading = styled.h1 `
    font-size: 1.5rem;
`;
// `credentialless` (Chromium-only) exempts the frame from the parent's
// COEP require-corp CORP check — live-crawler.streamr.network doesn't send
// Cross-Origin-Resource-Policy, so Safari/Firefox still block the frame
// until that server-side header lands. styled-components' default prop
// filter would strip the non-standard attribute, hence shouldForwardProp.
const StyledIframe = styled.iframe.withConfig({
    shouldForwardProp: () => true,
}) `
    width: 100%;
    height: 100%;
    background: var(--tv-ui-color-3);
`;
const StyledButton = styled(Button) `
    --Button_Background: var(--tv-ui-color-4);
    --Button_TextColor: var(--tv-ui-color-3);
    --Button_TextSize: 1.125rem;
    --Button_HoverBackground: var(--tv-ui-color-4);
    --Button_BorderRadius: 1rem;
    --Button_Padding: 1rem;
    --Button_HoverTransform: none;
    --Button_ActiveTransform: none;
    @media (min-width: 30rem) {
        --Button_Width: 20rem;
        margin: 0 auto;
    }
`;
const networkStatisticsPopup = Popup.create(NetworkStatisticsPopup);
export const showNetworkStatisticsPopup = () => {
    networkStatisticsPopup.pop().catch((_) => { });
};
